export default __webpack_public_path__ + "static/media/eligibility.e240acf5.svg";